<template>
  <router-view />
</template>

<script>
import Location from '@/mixins/Location'

export default {
  name: 'ec-dates-index',
  mixins: [Location],
  beforeRouteEnter (to, from, next) {
    if (from.name === null) {
      next(vm => {
        if (to.name !== 'webshop.store') {
          vm.getSiteData()
        }
      })
    } else {
      next(vm => {
        vm.$store.commit('setIsLoading', false)
      })
    }
  }
}
</script>
